<div
  class="card d-flex flex-column flex-grow-1"
  *ngIf="viewModel$ | async as vm"
>
  <div class="card-body d-flex flex-column flex-grow-1">
    <div class="navbar p-0 border-bottom mb-2">
      <ul class="nav nav-tabs border-bottom-0">
        <li class="nav-item">
          <a class="nav-link" routerLinkActive="active" routerLink="contact"
            >Contact</a
          >
        </li>
        <li class="nav-item">
          <a class="nav-link" routerLinkActive="active" routerLink="history"
            >History</a
          >
        </li>
        <li class="nav-item">
          <a class="nav-link" routerLinkActive="active" routerLink="faq">FAQ</a>
        </li>
        <li class="nav-item" *ngIf="!vm.scriptDisabled">
          <a class="nav-link" routerLinkActive="active" routerLink="script"
            >Script</a
          >
        </li>
        <li class="nav-item" *ngFor="let webTitle of vm.webTitles; index as i">
          <a
            class="nav-link"
            routerLinkActive="active"
            [routerLink]="['web', i]"
            >{{ webTitle }}</a
          >
        </li>
        <li class="nav-item" *ngIf="vm.testMode">
          <a class="nav-link" routerLinkActive="active" routerLink="information"
            >Information</a
          >
        </li>
      </ul>
      <span class="navbar-text">{{ vm.contactDetails }} </span>
    </div>
    <router-outlet></router-outlet>
  </div>
</div>
